<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="addPointsDialog" max-width="400">
            <v-card class="pa-3">
                <v-layout row justify-space-between>
                    <v-card-title class="headline pl-0 pt-0"
                        >Add Points</v-card-title
                    >
                </v-layout>
                <div
                    class="my-2 font-weight-medium text-danger"
                    v-if="!selected.length"
                >
                    NO STUDENTS SELECTED
                </div>
                <div
                    class="my-2 font-weight-medium"
                    v-if="selected.length"
                >
                    Selected ({{ selected.length }}):
                </div>
                <div v-if="selected.length" class="selected-students-list mb-2">
                    <div
                        v-for="(student, index) in selected"
                        :key="student.studentID || student.regID || index"
                        class="selected-student-row px-2 py-1"
                        :class="{ 'selected-student-row--divider': index + 1 < selected.length }"
                    >
                        <span class="font-weight-medium">{{ student.hebName }}</span>
                        <span class="grey--text mx-2">|</span>
                        <span>{{ [student.branch, student.class, student.section].filter(function(v) { return !!v; }).join('-') }}</span>
                        <span class="grey--text mx-2">|</span>
                        <span class="font-weight-medium">{{ student.pointsBalance !== null && student.pointsBalance !== undefined ? student.pointsBalance : 'N/A' }} pts</span>
                    </div>
                </div>
                <v-menu
                    v-model="datePickerMenu"
                    :close-on-content-click="false"
                    offset-y
                    full-width
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class=""
                            v-model="scanDate"
                            :value="scanDate"
                            label="Date"
                            readonly
                            ref="scanDate"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="scanDate"></v-date-picker>
                </v-menu>

                <v-text-field
                    class=""
                    v-model="addPoints"
                    label="Points"
                    type="number"
                    ref="addPoints"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-select
                    :items="pointTypes"
                    v-model="pointsType"
                    label="Points Type"
                    ref="pointsType"
                    :rules="[rules.required]"
                ></v-select>
                <v-text-field
                    class=""
                    v-model="addPointsNote"
                    label="Note"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="addPointsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="savePoints()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="resetPointsDialog" max-width="400">
            <v-card class="pa-3">
                <v-layout row justify-space-between>
                    <v-card-title class="headline pl-0 pt-0"
                        >Reset Points To 0</v-card-title
                    >
                </v-layout>
                <div
                    class="my-2 font-weight-medium text-danger"
                    v-if="!selected.length"
                >
                    NO STUDENTS SELECTED
                </div>
                <div
                    class="my-2 font-weight-medium"
                    v-if="selected.length"
                >
                    Selected ({{ selected.length }}):
                </div>
                <div v-if="selected.length" class="selected-students-list mb-2">
                    <div
                        v-for="(student, index) in selected"
                        :key="student.studentID || student.regID || index"
                        class="selected-student-row px-2 py-1"
                        :class="{ 'selected-student-row--divider': index + 1 < selected.length }"
                    >
                        <span class="font-weight-medium">{{ student.hebName }}</span>
                        <span class="grey--text mx-2">|</span>
                        <span>{{ [student.branch, student.class, student.section].filter(function(v) { return !!v; }).join('-') }}</span>
                        <span class="grey--text mx-2">|</span>
                        <span class="font-weight-medium">{{ student.pointsBalance !== null && student.pointsBalance !== undefined ? student.pointsBalance : 'N/A' }} pts</span>
                    </div>
                </div>
                <v-menu
                    v-model="resetDatePickerMenu"
                    :close-on-content-click="false"
                    offset-y
                    full-width
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="resetPointsDate"
                            :value="resetPointsDate"
                            label="Date"
                            readonly
                            ref="resetPointsDate"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="resetPointsDate"></v-date-picker>
                </v-menu>
                <v-text-field
                    v-model="resetPointsNote"
                    label="Note"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="resetPointsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveResetPoints()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="reportAbsentDialog" max-width="400">
            <v-card class="pa-3">
                <v-layout row justify-space-between>
                    <v-card-title class="headline pl-0 pt-0"
                        >Report Absent</v-card-title
                    >
                </v-layout>
                <div
                    class="my-2 font-weight-medium text-danger"
                    v-if="!selected.length"
                >
                    NO STUDENTS SELECTED
                </div>
                <div class="my-2 font-weight-medium" v-if="selected.length">
                    SELECTED:
                </div>
                <div style="overflow-y: auto; height: 200px">
                    <div v-for="(student, index) in selected">
                        <div class="mb-2">
                            {{ student.hebName + " " + student.class }}
                        </div>
                        <v-divider
                            class="my-2"
                            v-if="index + 1 < selected.length"
                        ></v-divider>
                    </div>
                </div>
                <v-menu
                    v-model="absentDatePickerMenu"
                    :close-on-content-click="false"
                    offset-y
                    full-width
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class=""
                            v-model="absentDate"
                            :value="absentDate"
                            label="Absent Date"
                            readonly
                            ref="absentDate"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="absentDate"></v-date-picker>
                </v-menu>
                <v-select
                    v-model="scanType"
                    :items="scanTypes"
                    label="Type"
                ></v-select>
                <div v-if="studentsScanned.length" class="text-danger">
                    <div class="font-weight-medium mb-2">
                        The below selected students are already scanned
                    </div>

                    <div>
                        <div v-for="(student, index) in studentsScanned">
                            <div class="mb-2">
                                {{
                                    student.hebName +
                                        " " +
                                        student.class +
                                        " - " +
                                        student.scanType
                                }}
                            </div>
                            <v-divider
                                class="my-2"
                                v-if="index + 1 < studentsScanned.length"
                            ></v-divider>
                        </div>
                    </div>
                    <v-radio-group class="mt-0" v-model="updateExisting" column>
                        <v-radio
                            color="success"
                            label="Update Existing"
                            value="update"
                        ></v-radio>
                        <v-radio
                            color="success"
                            label="Create New"
                            value="new"
                        ></v-radio>
                    </v-radio-group>
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="reportAbsentDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveAbsentReport()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
                <div v-if="studentsPresent.length" class="text-danger">
                    <div class="font-weight-medium mb-2">
                        The below selected students are already present
                    </div>

                    <div v-for="(student, index) in studentsPresent">
                        <div class="mb-2">
                            {{ student.hebName + " " + student.class }}
                        </div>
                        <v-divider
                            class="my-2"
                            v-if="index + 1 < studentsPresent.length"
                        ></v-divider>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Student Attendance Report",
        url: "",
        forDate: "",
        actions: [],
        selected: [],
        datePickerMenu: false,
        addPointsDialog: false,
        scanDate: "",
        resetDatePickerMenu: false,
        resetPointsDialog: false,
        resetPointsDate: "",
        processing: false,
        addPoints: "",
        addPointsNote: "",
        resetPointsNote: "",
        pointsType: "Used",
        pointTypes: ["Earned", "Used"],
        reportAbsentDialog: false,
        absentDatePickerMenu: false,
        absentDate: "",
        studentsPresent: [],
        studentsScanned: [],
        scanType: "ABSENT",
        scanTypes: [
            "ABSENT",
            "Absent-Day",
            "Abset-Brekfast",
            "Absent Breakfast Permission",
            "Late",
        ],
        updateExisting: "",

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value) => {
                    switch (value) {
                        case "PRESENT":
                            return "mdi-check-circle";
                        case "ABSENT":
                        case "Abset-Brekfast":
                        case "Absent-Day":
                            return "mdi-alpha-x-box";
                        case "Late":
                            return "mdi-clock";
                        case "MISSING":
                            return "mdi-close-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "PRESENT":
                            return "success";
                        case "ABSENT":
                        case "Abset-Brekfast":
                        case "Absent-Day":
                            return "#FFA726";
                        case "Late":
                            return "#ff9800";
                        case "MISSING":
                            return "#f35123";
                        default:
                            return "#fdb400";
                    }
                },
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Family ID",
                //link: "AccountView",
                format: "",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "hebName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Family Name",
                field: "familyName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scan Date",
                field: "scanDate",
                type: "date",
                //format: "MM/dd/yyyy hh:mm:ss a",
                format: "MM/dd/yyyy",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Number",
                field: "cardNum",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Points Balance",
                field: "pointsBalance",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {
        async beforeSetupGrid() {
            this.forDate = toISOLocal(new Date(moment())).substr(0, 10);

            this.userBranch = this.$store.state.authentication.branch;

            this.actions.push({
                text: "For Date",
                type: "datepicker",
                value: this.forDate,
                action: this.onDateChanged,
                //align: "right",
            });

            this.actions.push({
                text: "Add Points",
                action: this.openPointsDialog,
                showOnSelection: true,
            });
            this.actions.push({
                text: "Reset Points",
                action: this.openResetPointsDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Report Absent",
                action: this.openReportAbsentDialog,
                showOnSelection: true,
            });

            this.url =
                "studentAttendanceReport?forDate=" +
                this.forDate +
                (this.userBranch ? "&branch=" + this.userBranch : "&branch=");
        },
        onDateChanged(value) {
            this.forDate = value;
            this.url =
                "studentAttendanceReport?forDate=" +
                this.forDate +
                (this.userBranch ? "&branch=" + this.userBranch : "&branch=");

            this.$refs.grid.reloadDataSource(this.url);
        },
        openPointsDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.addPoints = "";
            this.scanDate = this.forDate;
            this.addPointsDialog = true;
        },
        openResetPointsDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.resetPointsDate = this.forDate;
            this.resetPointsNote = "";
            this.resetPointsDialog = true;
        },
        openReportAbsentDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.absentDate = this.forDate;
            this.scanType = "ABSENT";
            this.reportAbsentDialog = true;
        },
        async savePoints() {
            if (
                !this.$refs.addPoints.validate(true) ||
                !this.$refs.pointsType.validate(true)
            )
                return;

            if (!this.scanDate) {
                return this.$notify({
                    text: "Missing Date",
                    group: "notification",
                    type: "success",
                });
            }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/studentAttendanceCards/AddScans",
                    this.selected.map((student) => ({
                        cardNum: student.cardNum,
                        studentID: student.studentID,
                        regID: student.regID,
                        points: this.addPoints,
                        enteredBy: this.$store.state.authentication.user,
                        note: this.addPointsNote,
                        pointsType: this.pointsType,
                        scanDate: moment(this.scanDate).format(
                            "YYYY-MM-DD HH:mm:ss",
                        ),
                    })),
                );

                this.processing = false;
                this.addPointsDialog = false;
                this.$refs.grid.reloadGrid();

                this.$notify({
                    text: "Points Saved",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        async saveResetPoints() {
            if (!this.resetPointsDate) {
                return this.$notify({
                    text: "Missing Date",
                    group: "notification",
                    type: "success",
                });
            }

            try {
                this.processing = true;

                const now = moment();
                const resetDateTime = moment(this.resetPointsDate)
                    .hours(now.hours())
                    .minutes(now.minutes())
                    .seconds(now.seconds())
                    .format("YYYY-MM-DD HH:mm:ss");

                await this.$http.post(
                    "api/studentAttendanceCards/AddScans",
                    this.selected.map((student) => ({
                        cardNum: student.cardNum,
                        studentID: student.studentID,
                        regID: student.regID,
                        points: -(Number(student.pointsBalance) || 0),
                        enteredBy: this.$store.state.authentication.user,
                        note: this.resetPointsNote,
                        pointsType: "Used",
                        scanDate: resetDateTime,
                    })),
                );

                this.processing = false;
                this.resetPointsDialog = false;
                this.$refs.grid.reloadGrid();

                this.$notify({
                    text: "Points Reset",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        async saveAbsentReport() {
            this.studentsPresent = [];
            this.studentsScanned = [];

            if (!this.absentDate) {
                return this.$notify({
                    text: "Missing Absent Date",
                    group: "notification",
                    type: "success",
                });
            }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/studentAttendanceCards/reportAbsent",
                    {
                        students: this.selected,
                        user: this.$store.state.authentication.user,
                        date: moment(this.absentDate).format("YYYY-MM-DD"),
                        scanType: this.scanType,
                        updateExisting:
                            this.updateExisting == "update"
                                ? true
                                : this.updateExisting == "new"
                                ? false
                                : null,
                    },
                );

                if (response.failed) {
                    this.studentsPresent = response.studentsPresent;
                    this.processing = false;

                    return;
                }

                if (response.foundExisting) {
                    this.studentsScanned = response.studentsScanned;
                    this.processing = false;

                    return;
                }

                this.processing = false;
                this.reportAbsentDialog = false;
                this.studentsPresent = [];
                this.studentsScanned = [];
                this.updateExisting = "";

                this.$refs.grid.reloadGrid();

                this.$notify({
                    text: "Absent Reported",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.selected-students-list {
    max-height: 160px;
    overflow-y: auto;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: #fafafa;
}
.selected-student-row {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 13px;
}
.selected-student-row--divider {
    border-bottom: 1px solid #e0e0e0;
}
</style>
